import React from 'react';
import PropTypes from 'prop-types';
import ErrorBoundedProvider from '../react-on-rails/ErrorBoundedProvider';
import api from '../reducers/ApiReducer';
import { genericStoreSetup } from '../store';
import { Router, Route, hashHistory } from 'react-router';
import { syncHistoryWithStore, routerReducer as routing } from 'react-router-redux';

/**
 * Generic Foundry App component
 *
 */
const App = ({
  createStore = (initialState) => genericStoreSetup({ api, routing }, initialState),
  children,
  initialState,
  ...props
}) => {
  const store = createStore(initialState || {});
  const history = syncHistoryWithStore(hashHistory, store);

  const getChildRoutes = routes => {
    if (!routes || !routes.length) {
      return null;
    }
    const children = routes.map(route => (
      <Route key={route.routeKey} {...props} {...route} />
    ));
    return children;
  };

  return (
    <ErrorBoundedProvider store={store}>
      <Router onUpdate={() => window.scrollTo(0, 0)} history={history}>
        {React.Children.map(children, child => (
          <Route
            {...props}
            path={child.props.path}
            component={props => React.cloneElement(child, { ...props })}
            children={getChildRoutes(child.props.routes)}
          />
        ))}
      </Router>
    </ErrorBoundedProvider>
  );
};

App.propTypes = {
  children: PropTypes.node,
  createStore: PropTypes.func,
  initialState: PropTypes.object
};

export default App;
